export default function ({ store, $matomo }) {
  if (process.client && store.state.cookie.consents.analytics) {
    $matomo && $matomo.rememberConsentGiven()
  }
}
